import {AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren} from "@angular/core";
import {WatchService} from "../../services/watch.service";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {NvSelect2Component} from "../nv-select/nv-select2.component";
import {CollectionService} from "../../services/collection.service";
import {paramsHelper} from "../../helpers/params-helper";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import * as _ from "underscore";
import {inputUtils} from "../../helpers/input-utils";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {IDocument} from "../../interfaces/document.definition";
import {isUndefined} from "util";


@Component({
  selector: 'app-nv-dirigible-full-reward',
  templateUrl: './nv-dirigible-full-reward.component.html',
  styles: []
})
export class NvDirigibleFullRewardComponent implements OnInit, AfterViewInit{
  @ViewChildren(NvSelect2Component) children: QueryList<NvSelect2Component>;
  VAL_TYPES = VALUE_TYPE;

  private _document: any;
  private _pointer: any;
  private _subPointer: any;
  private _title: string;
  private loadedItems: IDocument[] = []; // todo: use service to load names of objects
  public size = {
    select: 0,
    input: 0,
    button: 0
  };

  @Input() set document(v: any) {
    this._document = v;
    this.updateModel();
  }

  @Input() set pointer(v: string) {
    this._pointer = v;
    this.updateModel();
  }

  @Input() set subPointer(v: string) {
    this._subPointer = v;
    this.updateModel();
  }

  @Input() set title(v: string) {
    this._title = v;
  }

  @Input() set small(v: boolean) {
    if (v) {
      this.resizeToSmallLayout();
    } else {
      this.resizeToNormalLayout();
    }
  };

  get title() { return this._title || "No label"; }
  get pointer() { return this._pointer; }
  get subPointer() { return this._subPointer; }
  get document() { return this._document; }


  constructor(private factoryService: FactoryService,
              private collectionService: CollectionService,
              private watchService: WatchService) {
    this.resizeToNormalLayout();
  }


  getRewards() {
    let rewards = JP.get(this.document, `${this.pointer}/rewardsList`);
    return rewards;
  }


  ngOnInit(): void {
    const search = paramsHelper
      .search()
      .addStringParam("category", GO_CATEGORIES.STUFF)
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          this.loadedItems = r.documents;
          //console.log(this.loadedItems);
          this.sendLoadedItemsToChildren();
          this.updateDisabledItemsInChildren();
        });
  }

  ngAfterViewInit(): void {
    this.updateChildren();

    this.children.changes
      .subscribe((): void => this.updateChildren());
  }


  onItemSelected() {
    this.updateDisabledItemsInChildren();
  }


  onRemoved() {
    this.watchService.notify();
  }


  onAddClick() {
    //this.factoryService.addRewardTo(this.document, this.pointer);
    let item = {resourceId: 0};
    JP.set(this.document, `${this.pointer}/rewardsList/-`, item);
  }


  private updateChildren() {
    this.sendLoadedItemsToChildren();
    this.updateDisabledItemsInChildren();
  }


  private sendLoadedItemsToChildren() {
    if (!this.children) {
      return;
    }

    this.children
      .forEach((c: NvSelect2Component): void => c.setItems(this.loadedItems));
  }


  private updateDisabledItemsInChildren() {
    if (!this.children) {
      return;
    }

    const disabledIds = _.pluck(this.getRewards(), "resourceId");
    this.children
      .forEach((c: NvSelect2Component): void => c.setDisabledItemIds(disabledIds));
  }


  private resizeToSmallLayout() {
    this.size.select = 7;
    this.size.input = 3;
    this.size.button = 1;
  }


  private resizeToNormalLayout() {
    this.size.select = 4;
    this.size.input = 1;
    this.size.button = 1;
  }

  private updateModel() {
    if (!isUndefined(this.pointer))
    {
      inputUtils.initializeArrayIfMissing(this.document, `${this.pointer}/rewardsList`);
    }

  }
}




// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-dirigible-full-reward/nv-dirigible-full-reward.component.ts